module.exports = require('./helpers/bundle-url').getBundleURL('kuLgW') + "time_clock.b0cbfc87.png";